"use client";

import { usePathname } from "next/navigation";

import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { stripePlans } from "@/features/stripe/data/stripe-plan";
import { PlanType } from "@/features/stripe/types/stripe-plan";

import { useArticleInfo } from "../services/article-info";
import { useArticleList } from "../services/article-list";

export type BlogDetailMaskType = "none" | "subscribe" | "login";

export const useBlogDetailsMaskType = () => {
  let type: BlogDetailMaskType = "none";

  const { isUnauthenticated, profile, isFetchingUserData } = useAuth();
  const permittedPlans = new Set<PlanType>(
    stripePlans.filter((plan) => plan !== "Free" && !plan.includes("Beginning"))
  );
  const isSubscribed =
    !isUnauthenticated && permittedPlans.has(profile?.plan as PlanType);

  const pathname = usePathname();
  const slug = pathname.split("/").pop();
  const { data: articleList } = useArticleList({});
  const articleId = articleList?.find(
    (article) => article.slug === slug
  )?.articleId;
  const { data: articleInfo } = useArticleInfo({ articleId: articleId ?? "" });
  const permission = articleInfo?.permission ?? "subscribe";

  if (!isFetchingUserData) {
    if (!isSubscribed && permission.toLowerCase() === "subscribe")
      type = "subscribe";
    if (isUnauthenticated) type = "login";
  }
  return { type };
};
